const environments = {
    dev: {
        url: "http://localhost:9001/",
        users: {
            gerencia: 4,
            administracion: 5,
            contabilidad: 6,
        },
        version: "dev"
    },
    prod: {
        url: "https://api.epcmhub.com/",
        users: {
            gerencia: 3,
            administracion: 142,
            contabilidad: 39,
        },
        version: "1.2",
    },
}

const Environment = environments.prod

export default Environment